import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

export function initDatadog() {
  if (import.meta.env.MODE === 'development') return;

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
    site: 'us3.datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: import.meta.env.VITE_DD_SERVICE_NAME,
    env: import.meta.env.VITE_ENVIRONMENT,
    version: import.meta.env.VITE_VERSION,
    forwardReports: 'all',
  });

  datadogRum.init({
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
    applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
    site: 'us3.datadoghq.com',
    service: import.meta.env.VITE_DD_SERVICE_NAME,
    env: import.meta.env.VITE_ENVIRONMENT,
    sessionSampleRate: 100,
    sessionReplaySampleRate: Number(import.meta.env.VITE_DD_REPLAY_SAMPLE_RATE) || 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    version: import.meta.env.VITE_VERSION,
  });
  datadogRum.startSessionReplayRecording();
}
